import { useEffect, useState } from 'react';

import validate from './OfferingInstanceAddFormValidation';

import useOfferingsData from '../../../../../state/offerings/UseOfferingsData';

import useEnvironmentVariableData from '@usas/ui-web/state/environmentVariable/UseEnvironmentVariableData';

import useForm from '@usas/ui-web/utils/UseForm';
import { BLANK_DATE_STRING, DEFAULT_ID } from '@usas/ui-web/utils/Constants';

const FEE_TYPE_NAME = 'USAS';

const INITIAL_STATE = {
  areOfferingOptionsLoaded: false,
  offeringOptions: [],
  apiErrorMessage: ''
};

const INITIAL_FORM_STATE = {
  offeringId: DEFAULT_ID,
  offeringName: '',
  isClubOffering: false,
  defaultRegStartDate: BLANK_DATE_STRING,
  defaultRegEndDate: BLANK_DATE_STRING,
  defaultEffectiveDate: BLANK_DATE_STRING,
  defaultExpirationDate: BLANK_DATE_STRING,
  feeAmount: 0,
  renewalFeeAmount: null,
  enableMaxLscFeeAmount: false,
  maxLscFeeAmount: null
};

const useOfferingInstanceAddForm = (onSubmitFormCallback, reportPeriodObj) => {
  const { USAS_ORG_UNIT_ID } = useEnvironmentVariableData();
  const { getAvailableOfferings } = useOfferingsData();
  const { formState, errorState, setFormState, handleSubmit, updateFormState,
  } = useForm(INITIAL_FORM_STATE, formatBeforeSubmit, validate);
  const [state, setState] = useState(INITIAL_STATE);

  const onEnableMaxLscFeeAmountChanged = (value) => {
    setFormState({
      ...formState,
      enableMaxLscFeeAmount: value,
      maxLscFeeAmount: value === true ? 0 : null
    });
  };

  const onOfferingTypeChanged = (value) => {
    const offeringType = state.offeringOptions.find((x) => x.id === value);

    if (offeringType) {
      setFormState({
        ...formState,
        offeringId: value,
        offeringName: offeringType.name,
        isClubOffering: offeringType.isClubOffering === true,
        renewalFeeAmount: offeringType.isClubOffering === true ? 0 : null
      });
    }
  };

  useEffect(() => {
    if (state.areOfferingOptionsLoaded === true) {
      if (state.offeringOptions.length > 0) {
        setFormState({
          ...formState,
          offeringId: state.offeringOptions[0]?.id,
          offeringName: state.offeringOptions[0]?.name,
          isClubOffering: state.offeringOptions[0]?.isClubOffering === true,
          renewalFeeAmount: state.offeringOptions[0]?.isClubOffering === true ? 0 : null
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.areOfferingOptionsLoaded]);

  useEffect(() => {
    if (reportPeriodObj?.reportPeriodId > 0) {
      const getAvailableOfferingsPromise = getAvailableOfferings(reportPeriodObj.reportPeriodId);

      if (getAvailableOfferingsPromise ?? false) {
        getAvailableOfferingsPromise.then((newState) => {
          if (newState ?? false) {
            const options = newState.arrayData.map((x) => { return { id: x.offeringId, name: x.offeringName, isClubOffering: x.isClubRegistrationOffering === true } });

            setState({
              ...state,
              areOfferingOptionsLoaded: true,
              offeringOptions: options
            });
          }
        }).catch((e) => {
          setState({
            ...state,
            apiErrorMessage: e?.message || 'Failed to retrieve available offerings',
          });
        });
      }
    } else {
      setState({
        ...state,
        apiErrorMessage: 'Failed to load available offerings'
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reportPeriodObj]);

  function formatBeforeSubmit(formState) {
    if (USAS_ORG_UNIT_ID) {
      const submitObj = {
        reportPeriodId: reportPeriodObj.reportPeriodId,
        orgUnitId: USAS_ORG_UNIT_ID,

        offeringId: formState.offeringId,
        defaultRegStartDate: formState.defaultRegStartDate,
        defaultRegEndDate: formState.defaultRegEndDate,
        defaultEffectiveDate: formState.defaultEffectiveDate,
        defaultExpirationDate: formState.defaultExpirationDate,
        feeAmount: formState.feeAmount,
        renewalFeeAmount: formState.isClubOffering === true ? formState.renewalFeeAmount : null,
        maxLscFeeAmount: formState.enableMaxLscFeeAmount === true ? formState.maxLscFeeAmount : null
      };

      onSubmitFormCallback(submitObj);
    }
  }

  return {
    feeTypeName: FEE_TYPE_NAME,
    formState,
    errorState,
    state,

    updateFormState,
    onEnableMaxLscFeeAmountChanged,
    onOfferingTypeChanged,
    handleSubmit
  };
};

export default useOfferingInstanceAddForm;